import { NextApiRequest, NextApiResponse } from 'next'
import { PROMOTION_TYPE } from 'typings'
import type { Template } from '../../../../src/components/Form/Template/typings'
import { Promotion } from '../../../../src/components/typings'

// Mock template data
const MOCK_TEMPLATE: Template = {
  id: 'template-123',
  name: 'Black Friday Template',
  description: 'Template para promoções de Black Friday',
  type: PROMOTION_TYPE.CAMPAIGN,
  metadata: {
    createdAt: '2024-01-01T00:00:00.000Z',
    updatedAt: '2024-01-01T00:00:00.000Z',
  },
  promotion: {
    type: PROMOTION_TYPE.CAMPAIGN,
    general: {
      active: true,
      name: 'Promoção mockada',
      description: '',
    },
    storefront: {
      highlight: false,
      additionalInformation: [],
    },
    campaign: {
      scope: {
        applyTo: 'filteredItems',
        skus: {
          items: [
            {
              id: '1',
              name: 'Camiseta Branca Lisa P',
            },
          ],
          operator: 'equals',
        },
      },
      benefit: {
        type: 'percentualShipping',
        applyTo: 'selected',
        value: 13,
        selectedMethods: [
          {
            id: 'Rapidex',
            name: 'Rapidex',
          },
        ],
      },
      audiences: [
        {
          id: '2459b6c6-55f3-4d79-bb1c-a50ba5e0e64e',
          name: 'CampanhaBacaDandy',
        },
      ],
    },
    restrictions: {
      accumulate: true,
      accumulateWithManualPrices: false,
      origin: 'Marketplace',
    },
  } as unknown as Omit<Promotion, 'id'>,
}

export async function handleGetTemplateByIdMock(
  req: NextApiRequest,
  res: NextApiResponse
) {
  // Extract ID from URL (format: /template/{id})
  const url = req.url?.replace(/^\/api\/proxy\//, '') || ''
  const match = url.match(/template\/([^/]+)$/)
  const id = match?.[1]

  if (!id) {
    return res.status(400).json({
      message: 'Template ID is required',
    })
  }

  // Return mock template with the requested ID
  return res.status(200).json({
    ...MOCK_TEMPLATE,
    id,
  })
}

export async function handlePostTemplateMock(
  req: NextApiRequest,
  res: NextApiResponse
) {
  return res.status(200).json({
    ...MOCK_TEMPLATE,
    id: 'template-' + Date.now(),
  })
}
